function LeadershipSectionLabel({ children, variant = 'red', className = '' }) {
  return (
    <span className={`leadership-label leadership-label--${variant} ${className}`.trim()}>
      <span className="leadership-label__bar" aria-hidden="true" />
      {children}
    </span>
  )
}

export default LeadershipSectionLabel
